
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/site/founding-members",
      function () {
        return require("private-next-pages/site/founding-members.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/site/founding-members"])
      });
    }
  